import type { FPlusLibraryScopeOuput } from '@festina/configuration-general-types/configuration'
import { notEmpty } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { MarkdownViewer } from '../markdownviewer/MarkdownViewer'
import { FPlusFunctionScopeList } from './FPlusFunctionScopeList'

type FPlusDefaultLibraryProps = {
  library: FPlusLibraryScopeOuput
}

export const FPlusDefaultLibrary = ({ library }: FPlusDefaultLibraryProps) => {
  const translate = useTranslate()

  return (
    <FPlusFunctionScopeList
      functions={library.functions?.filter(notEmpty) ?? []}
    >
      <p className="text-center text-lg">
        {translate('templateViewer.sidebar.scopePopover.typeDocumentation')}
      </p>
      <MarkdownViewer shouldTransformLinksToDocSite className="text-left">
        {library.typeDocumentation ??
          translate('templateViewer.sidebar.scopePopover.noTypeDocumentation')}
      </MarkdownViewer>
      <p className="text-center text-lg">Functions</p>
    </FPlusFunctionScopeList>
  )
}
